import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { Newsletter } from "@/components/Newsletter";
import { api } from "@/lib/apiClient";
import Seo from "@/components/Seo";

export default function Journal() {
  const [posts, setPosts] = useState([]);
  const [cat, setCat] = useState("");

  useEffect(() => { api.get("/journal", { params: { published: true } }).then((r) => setPosts(r.data)).catch(() => {}); }, []);
  const cats = Array.from(new Set(posts.map((p) => p.category)));
  const shown = cat ? posts.filter((p) => p.category === cat) : posts;

  return (
    <div className="bg-[#FFF7EC] min-h-screen">
      <Seo title="Journal — India Travel Notes" description="Destination guides, pilgrimage guides, travel inspiration and stories from VacanzaGo." />
      <div className="pt-28 pb-16 max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal className="max-w-3xl mb-10">
          <p className="eyebrow">Journal</p>
          <h1 className="font-display text-5xl sm:text-6xl font-medium tracking-tight mt-3 text-[#2A1808]">India travel notes</h1>
          <p className="mt-4 text-lg text-[#553204]">Guides, inspiration and stories from the road.</p>
        </Reveal>
        <div className="flex flex-wrap gap-2 mb-10">
          <button onClick={() => setCat("")} className={`rounded-full border px-4 py-2 text-sm ${!cat ? "bg-[#F49E1A] border-[#F49E1A] text-white" : "border-[#553204]/20 text-[#553204]"}`}>All</button>
          {cats.map((c) => <button key={c} onClick={() => setCat(c)} className={`rounded-full border px-4 py-2 text-sm ${cat === c ? "bg-[#F49E1A] border-[#F49E1A] text-white" : "border-[#553204]/20 text-[#553204]"}`}>{c}</button>)}
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {shown.map((p, i) => (
            <Reveal key={p.slug} delay={(i % 3) * 70}>
              <Link to={`/journal/${p.slug}`} data-testid={`journal-card-${p.slug}`} className="group block rounded-md overflow-hidden border border-[#553204]/10 bg-[#FFFBF5]">
                <div className="img-zoom aspect-[3/2] overflow-hidden"><img src={p.cover_image} alt={p.title} className="h-full w-full object-cover" loading="lazy" /></div>
                <div className="p-6">
                  <p className="eyebrow">{p.category}</p>
                  <h2 className="font-display text-2xl mt-2 text-[#2A1808] leading-tight">{p.title}</h2>
                  <p className="mt-2 text-sm text-[#8A6B47] line-clamp-3">{p.excerpt}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
      <Newsletter />
    </div>
  );
}
